<template>
  <div>
    <AdminLayout Title="Members" :isRequired="false">
      <div class="container">
        <DashboardSkeleton class="pt-6" v-if="loading" />
        <div class="row pt-6" v-else>
          <div class="col-12 col-lg-4">
            <div class="row bg-white py-3 px-1 rounded-2 b-color">
              <div class="col-12">
                <div
                  class="card p-2 border-0 bg-card1 d-flex justify-content-between flex-column"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="text-body-secondary">Total No of Members</p>
                    <img
                      src="../../assets/admin-dashboard-meetings.png"
                      class="img-fluid d-flex align-self-start"
                      width="50"
                    />
                  </div>
                  <div class="d-flex">
                    <h5 class="mt-3 fw-semibold">
                      {{ membersCounts?.member_count }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-8">
            <div class="bg-white p-2 rounded-2 b-color">
              <div class="row d-flex align-items-center">
                <div class="col-12 col-lg-6">
                  <input
                    type="text"
                    placeholder="Enter to search"
                    class="form-control p-2 ms-0"
                  />
                </div>
                <div class="col-12 col-lg-6 d-flex justify-content-end">
                  <div class="d-flex p-1 mb-1">
                    <button class="m-1 btn-accent1 p-1">Active</button>

                    <button class="m-1 btn-accent2 p-1" href="#">
                      Blocked
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">

              <table class="table mt-3 rounded-2">
                <thead class="bg-grey">
                  <tr class="bg-grey">
                    <td class="text-body-secondary">Full Name</td>
                    <td class="text-body-secondary">Email Address</td>
                    <td class="text-center text-body-secondary">Status</td>
                    <td class="text-end text-body-secondary">Date Joined</td>
                    <td class="text-end text-body-secondary">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="members.length == 0">
                    <td class="text-semibold text-center">No Members</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr v-for="member in members" :key="member.id">
                    <td class="d-md-flex align-items-center">
                      <img
                        :src="
                          member?.photo
                            ? member?.photo
                            : require('@/assets/dummy-avatar-logo.svg')
                        "
                        alt=""
                        class="img-fluid me-2 d-none d-md-flex"
                        width="50"
                        height="50"
                      />{{ member?.first_name }} {{ member?.last_name }}
                    </td>
                    <td >{{ member?.email }}</td>
                    <td class="text-center">
                      <button class="btn-active">Active</button>
                    </td>
                    <td class="text-end">
                      {{ getFormattedDate(member?.created_at) }}
                    </td>
                    <td class="text-end">
                      <router-link
                        :to="{
                          name: 'AdminMemberDetails',
                          params: { id: member?.id },
                        }"
                        class="btn-active text-decoration-none"
                        ><i class="bi bi-eye-fill ms-1"></i
                      ></router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <nav aria-label="Page navigation" v-if="links.length != 0">
              <ul class="pagination justify-content-end">
                <!-- Previous button -->
                <li
                  class="page-item"
                  :class="{ disabled: !links[0]?.url }"
                  @click="changePage(currentPage - 1)"
                >
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>

                <!-- Page links -->
                <li
                  class="page-item"
                  v-for="link in links.slice(1, -1)"
                  :key="link.label"
                  :class="{ active: link?.active }"
                  @click="changePageFromUrl(link?.url)"
                >
                  <a class="page-link" href="#">{{ link?.label }}</a>
                </li>

                <!-- Next button -->
                <li
                  class="page-item"
                  :class="{ disabled: !links[links.length - 1]?.url }"
                  @click="changePage(currentPage + 1)"
                >
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </AdminLayout>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";

import AdminLayout from "@/components/Layouts/AdminLayout.vue";
import DashboardSkeleton from "@/components/DashboardSkeleton.vue";

import { catchAxiosExceptions } from "@/Plugins/handleExceptions";
import { getFormattedDate, getFormattedAmount } from "@/Utils/handleResponse";

import utils from "@/Plugins/utils";
import axios from "@/Plugins/axios";

const loading = ref(false);

const currentPage = ref(1);
const totalPages = ref(0);
const paginator = ref({});
const links = ref([]);

const membersCounts = ref({});
const members = ref([]);

const changePageFromUrl = (url) => {
  if (url) {
    const urlParams = new URL(url).searchParams;
    const page = urlParams.get("page");
    initMembers(parseInt(page, 10));
  }
};

const changePage = (page) => {
  if (page > 0 && page <= totalPages.value) {
    initMembers(page);
  }
};

async function initMembers(page = 1) {
  loading.value = true;
  try {
    const _members = await axios.get(`/admin/members?page=${page}`);
    const _membersCount = await axios.get(`/admin/member-count`);
    members.value = _members.data.data;

    paginator.value = _members.data.meta;
    links.value = paginator.value.links;
    // gettingNextPage.value = false;
    currentPage.value = paginator.value.current_page;
    totalPages.value = paginator.value.total;
    membersCounts.value = _membersCount.data.data;
    loading.value = false;
  } catch (error) {
    utils.showToast(catchAxiosExceptions(error).msg, "error");
    loading.value = false;
  }
}

onMounted(() => {
  initMembers(currentPage.value);
});
</script>
<style scoped>
/* *{
  outline: 1px solid red;
} */

.btn-accent1 {
  background-color: rgba(234, 241, 255, 1);
  color: rgba(24, 41, 101, 1);
  border-radius: 5px;
  border: none;
  padding: 0.5rem 0.5rem !important;
}
.btn-accent2 {
  background-color: rgba(246, 246, 246, 1);
  color: rgba(96, 96, 96, 1);
  border-radius: 5px;
  border: none;
  padding: 0.5rem 0.5rem !important;
}

.filter {
  border: 1px solid rgba(218, 229, 239, 1);
  backdrop-filter: blur(20px);
  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.02);
  border-radius: 9px;
}
.pt-6 {
  padding-top: 6rem !important;
}

.btn-active {
  border: none !important;
  color: #0077ff !important;
  background-color: #eaf5ff !important;
  padding: 0.3rem !important;
  border-radius: 5px;
}

.bg-white {
  background-color: #fff;
}

.bg-card1 {
  background-color: #e4f5ff !important;
}
.bg-card2 {
  background-color: #e1ffea !important;
}

.b-color {
  border: 1px solid #ddedff !important;
}
</style>
